// extracted by mini-css-extract-plugin
module.exports = {"background":"footer_background__2WMcc","text":"footer_text__1764t"};